export default function GS_Parentheses() {
  return (
    <div className="p-4">
      <h1>GS Parentheses</h1>
    </div>
  );
}
